import React from "react";
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as Yup from 'yup'
import { Row, Col, Modal, Icon, Typography } from 'antd'
import { FastField, Formik } from 'formik'
import typo, { MESSAGE } from '../../constants/dictionaries'
import styled from "styled-components";
import { isEmpty } from "lodash";
// Components
import Input from '../Common/Input'
import InputCV from '../Common/Input/InputCV'
import Button from '../Buttons'
import ValidatedText from "../Common/ValidatedText";
import DisplayFormikState from "../Table/DisplayFormikState";
import Api from '../../api';
import Message from "../Messages";
import constants from "../../constants/constant"
import helper from "../../helper/helper"
import Select from "../Common/Select"
import Api_tnn from "../../api/api.tnn";
import Api_spatial from "../../api/api.spatial";
import Api_quantrac from "../../api/api.quantrac";
import InputNumber from "../Common/NumberField/inputNumber"
import UpFile from "../CongTrinh/FileDinhKem/Modal"
const { Text } = Typography;
const ControllerInput = styled.div`
  padding: 0 10px 0 10px;
`;
const schema = Yup.object().shape({
    sheetname: Yup.string().required(typo.cscore_required),
    dongbatdau: Yup.number().required(typo.cscore_required),
    dongketthuc: Yup.number().required(typo.cscore_required),
    cot_dotQuanTracSo: Yup.number().required(typo.cscore_required),
    cot_dotQuanTrac_Ten: Yup.number().required(typo.cscore_required),
    cot_thongsodautien: Yup.number().required(typo.cscore_required),
    cot_vitriquantrac: Yup.number().required(typo.cscore_required),
});
class ConvertExcel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataThongSo: [],
            initialValues: {},
            fileList: [],
            list_thongso: undefined
        };
    }
    componentDidMount() {
        this.GetQT_ThongSos_By_TPMT()
        this.setState({
            initialValues: {
                ...this.state.initialValues,
                sheetname: "Sheet1",
                dongbatdau: 3,
                cot_dotQuanTracSo: 12,
                cot_dotQuanTrac_Ten: 13,
                cot_thongsodautien: 20,
                cot_vitriquantrac: 14,
                cot_vitriquantrac_x: 16,
                cot_vitriquantrac_y: 17,
                cot_vitriquantrac_diadiem: 15,
                cot_mau_kyhieu: 2,
                cot_mau_ten: 3,
                cot_mau_tinhtrang: 4,
                cot_mau_mota: 5,
                cot_donvithuchien: 6,
                cot_nguoilaymaus: 7,
                cot_nguoigiamsats: 8,
                cot_ngaylaymau: 9,
                cot_ngaynhanmau: 10,
                cot_ngayphantich: 11,
                cot_luuluong: 18,
                cot_nguonnuoc: 19,
                kyhieuBoQua: "-",
                kyHieuNhoHon: "<",
                kyhieuLonHon: ">",
            }
        })
    }
    GetQT_ThongSos_By_TPMT = () => {
        new Api_quantrac()
            .GetQT_ThongSos_By_TPMT({
                token: this.props.user.access_token,
                tpmt_ma: this.props.doiTuongQT,
            })
            .then(res => {
                this.setState({
                    dataThongSo: res.map((item, index) => ({ ...item, thongso: item.tenThongSo + " (" + item.tenDonVi + ")" + " - " + item.kyHieuThongSo })),
                });
            }).catch(err => {
                Message.error(err.message)
            });
    };
    GetExcelFromThietLapConvert = (value) => {
        new Api_tnn()
            .GetExcelFromThietLapConvert({
                token: this.props.user.access_token,
                sheetname: value.sheetname,
                cot_mau_kyhieu: value.cot_mau_kyhieu ? value.cot_mau_kyhieu : 0,
                cot_mau_ten: value.cot_mau_ten ? value.cot_mau_ten : 0,
                cot_mau_tinhtrang: value.cot_mau_tinhtrang ? value.cot_mau_tinhtrang : 0,
                cot_mau_mota: value.cot_mau_mota ? value.cot_mau_mota : 0,
                cot_donvithuchien: value.cot_donvithuchien ? value.cot_donvithuchien : 0,
                cot_nguoilaymaus: value.cot_nguoilaymaus ? value.cot_nguoilaymaus : 0,
                cot_nguoigiamsats: value.cot_nguoigiamsats ? value.cot_nguoigiamsats : 0,
                cot_ngaylaymau: value.cot_ngaylaymau ? value.cot_ngaylaymau : 0,
                cot_ngaynhanmau: value.cot_ngaynhanmau ? value.cot_ngaynhanmau : 0,
                cot_ngayphantich: value.cot_ngayphantich ? value.cot_ngayphantich : 0,
                cot_dotQuanTracSo: value.cot_dotQuanTracSo,
                cot_dotQuanTrac_Ten: value.cot_dotQuanTrac_Ten,
                cot_vitriquantrac: value.cot_vitriquantrac,
                cot_vitriquantrac_diadiem: value.cot_vitriquantrac_diadiem ? value.cot_vitriquantrac_diadiem : 0,
                cot_vitriquantrac_x: value.cot_vitriquantrac_x ? value.cot_vitriquantrac_x : 0,
                cot_vitriquantrac_y: value.cot_vitriquantrac_y ? value.cot_vitriquantrac_y : 0,
                cot_luuluong: value.cot_luuluong ? value.cot_luuluong : 0,
                cot_nguonnuoc: value.cot_nguonnuoc ? value.cot_nguonnuoc : 0,
                cot_thongsodautien: value.cot_thongsodautien ? value.cot_thongsodautien : 0,
                list_thongso: JSON.stringify(this.state.list_thongso)
            })
            .then(res => {

            }).catch(err => {
                Message.error(err.message)
            });
    };
    selectThongSo = (value, name) => {
        let datas = []
        value.map((e, index) => {
            let thongso = []
            thongso = this.state.dataThongSo.filter(i => i.idThongSo === e)[0]
            datas.push(thongso)
        })
        this.setState({
            list_thongso: datas.map((item, idx) => ({
                idThongSo: item.idThongSo,
                tenThongSo: item.tenThongSo,
                kyHieuThongSo: item.kyHieuThongSo,
                idDonVi: item.idDonVi,
                tenDonVi: item.tenDonVi
            }))
        })
    }
    parentHandle = (fileList) => {
        this.setState({ fileList: fileList })
    }
    thietLapMau = (data) => {
        const { list_thongso } = this.state
        if (data.sheetname && data.cot_dotQuanTracSo && data.cot_dotQuanTrac_Ten && data.cot_vitriquantrac && list_thongso) {
            this.GetExcelFromThietLapConvert(data)
        } else {
            Message.warning("Yêu cầu nhập đủ các thông số cần thiết")
        }
    }
    render() {
        const {
            isOpen = false,
            handleAdd,
            handleCancel,
            doiTuongQT,
            idGiayPhep,
            user } = this.props
        const { initialValues, dataThongSo, fileList } = this.state
        return (
            <Modal
                visible={isOpen}
                title={"Chuyển đổi kết quả quan trắc từ Excel"}
                footer={false}
                onCancel={() => handleCancel(fileList, user)}
                maskClosable={false}
                width="800px"
            >
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={(value, actions) => {
                        if (fileList.length > 0) {
                            new Api_tnn()
                                .ConvertExcelKQQT({
                                    token: this.props.user.access_token,
                                    idgiayphep: idGiayPhep,
                                    filename: fileList[0].fileName,
                                    dongbatdau: value.dongbatdau,
                                    dongketthuc: value.dongketthuc,
                                    dong_cmax: value.dong_cmax ? value.dong_cmax : 0,
                                    kyhieuBoQua: value.kyhieuBoQua ? value.kyhieuBoQua : "",
                                    kyhieuLonHon: value.kyhieuLonHon ? value.kyhieuLonHon : "",
                                    kyHieuNhoHon: value.kyHieuNhoHon ? value.kyHieuNhoHon : "",
                                    sheetname: value.sheetname,
                                    cot_mau_kyhieu: value.cot_mau_kyhieu ? value.cot_mau_kyhieu : 0,
                                    cot_mau_ten: value.cot_mau_ten ? value.cot_mau_ten : 0,
                                    cot_mau_tinhtrang: value.cot_mau_tinhtrang ? value.cot_mau_tinhtrang : 0,
                                    cot_mau_mota: value.cot_mau_mota ? value.cot_mau_mota : 0,
                                    cot_donvithuchien: value.cot_donvithuchien ? value.cot_donvithuchien : 0,
                                    cot_nguoilaymaus: value.cot_nguoilaymaus ? value.cot_nguoilaymaus : 0,
                                    cot_nguoigiamsats: value.cot_nguoigiamsats ? value.cot_nguoigiamsats : 0,
                                    cot_ngaylaymau: value.cot_ngaylaymau ? value.cot_ngaylaymau : 0,
                                    cot_ngaynhanmau: value.cot_ngaynhanmau ? value.cot_ngaynhanmau : 0,
                                    cot_ngayphantich: value.cot_ngayphantich ? value.cot_ngayphantich : 0,
                                    cot_dotQuanTracSo: value.cot_dotQuanTracSo,
                                    cot_dotQuanTrac_Ten: value.cot_dotQuanTrac_Ten,
                                    cot_vitriquantrac: value.cot_vitriquantrac,
                                    cot_vitriquantrac_diadiem: value.cot_vitriquantrac_diadiem ? value.cot_vitriquantrac_diadiem : 0,
                                    cot_vitriquantrac_x: value.cot_vitriquantrac_x ? value.cot_vitriquantrac_x : 0,
                                    cot_vitriquantrac_y: value.cot_vitriquantrac_y ? value.cot_vitriquantrac_y : 0,
                                    cot_luuluong: value.cot_luuluong ? value.cot_luuluong : 0,
                                    cot_nguonnuoc: value.cot_nguonnuoc ? value.cot_nguonnuoc : 0,
                                    cot_thongsodautien: value.cot_thongsodautien ? value.cot_thongsodautien : 0,
                                    list_thongso: this.state.list_thongso
                                })
                                .then(res => {
                                    handleAdd(res.data.map((e) => ({ ...e, list_KQQT: JSON.stringify(e.list_KQQT), daXoa: 0 })), fileList, user)
                                    Message.info(res.message)
                                }).catch(err => {
                                    Message.error(err.message)
                                });
                        } else {
                            Message.warning(MESSAGE.CSCORE_CHUA_CHON_FILE)
                        }
                    }}
                    validationSchema={schema}
                    render={({ handleChange, handleSubmit, values, errors, touched, setFieldValue }) => (
                        <form onSubmit={handleSubmit} autoComplete={false}>
                            <Row>
                                <Col span={12}>
                                    <ControllerInput>
                                        <FastField name="sheetname" render={({ field }) => (
                                            <Input label={typo.cscore_sheetname} classLabel="d-flex" width="162px" {...field} />)} />
                                    </ControllerInput>
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: "10px" }}>
                                <Col span={8}>
                                    <ControllerInput>
                                        <InputNumber min={0}
                                            label={typo.cscore_dongbatdau}
                                            id="dongbatdau"
                                            onChange={value => setFieldValue("dongbatdau", value)}
                                            value={values.dongbatdau}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_dongketthuc}
                                            id="dongketthuc"
                                            onChange={value => setFieldValue("dongketthuc", value)}
                                            value={values.dongketthuc}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_dong_cmax}
                                            id="dong_cmax"
                                            onChange={value => setFieldValue("dong_cmax", value)}
                                            value={values.dong_cmax}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_dotQuanTracSo}
                                            id="cot_dotQuanTracSo"
                                            onChange={value => setFieldValue("cot_dotQuanTracSo", value)}
                                            value={values.cot_dotQuanTracSo}

                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_dotQuanTrac_Ten}
                                            id="cot_dotQuanTrac_Ten"
                                            onChange={value => setFieldValue("cot_dotQuanTrac_Ten", value)}
                                            value={values.cot_dotQuanTrac_Ten}

                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_thongsodautien}
                                            id="cot_thongsodautien"
                                            onChange={value => setFieldValue("cot_thongsodautien", value)}
                                            value={values.cot_thongsodautien}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_vitriquantrac}
                                            id="cot_vitriquantrac"
                                            onChange={value => setFieldValue("cot_vitriquantrac", value)}
                                            value={values.cot_vitriquantrac}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_vitriquantrac_x}
                                            id="cot_vitriquantrac_x"
                                            onChange={value => setFieldValue("cot_vitriquantrac_x", value)}
                                            value={values.cot_vitriquantrac_x}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_vitriquantrac_y}
                                            id="cot_vitriquantrac_y"
                                            onChange={value => setFieldValue("cot_vitriquantrac_y", value)}
                                            value={values.cot_vitriquantrac_y}
                                            mandatory={false}
                                            width="50px"
                                        />
                                    </ControllerInput>
                                </Col>
                                <Col span={8}>
                                    <ControllerInput>
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_vitriquantrac_diadiem}
                                            id="cot_vitriquantrac_diadiem"
                                            onChange={value => setFieldValue("cot_vitriquantrac_diadiem", value)}
                                            value={values.cot_vitriquantrac_diadiem}
                                            width="50px"
                                            mandatory={false}
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_mau_kyhieu}
                                            id="cot_mau_kyhieu"
                                            onChange={value => setFieldValue("cot_mau_kyhieu", value)}
                                            value={values.cot_mau_kyhieu}
                                            width="50px"
                                            mandatory={false}
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_mau_ten}
                                            id="cot_mau_ten"
                                            onChange={value => setFieldValue("cot_mau_ten", value)}
                                            value={values.cot_mau_ten}
                                            width="50px"
                                            mandatory={false}
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_mau_tinhtrang}
                                            id="cot_mau_tinhtrang"
                                            onChange={value => setFieldValue("cot_mau_tinhtrang", value)}
                                            value={values.cot_mau_tinhtrang}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_mau_mota}
                                            id="cot_mau_mota"
                                            onChange={value => setFieldValue("cot_mau_mota", value)}
                                            value={values.cot_mau_mota}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_donvithuchien}
                                            id="cot_donvithuchien"
                                            onChange={value => setFieldValue("cot_donvithuchien", value)}
                                            value={values.cot_donvithuchien}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_nguoilaymaus}
                                            id="cot_nguoilaymaus"
                                            onChange={value => setFieldValue("cot_nguoilaymaus", value)}
                                            value={values.cot_nguoilaymaus}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_nguoigiamsats}
                                            id="cot_nguoigiamsats"
                                            onChange={value => setFieldValue("cot_nguoigiamsats", value)}
                                            value={values.cot_nguoigiamsats}
                                            mandatory={false}
                                            width="50px"
                                        />
                                    </ControllerInput>
                                </Col>
                                <Col span={8}>
                                    <ControllerInput>
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_ngaylaymau}
                                            id="cot_ngaylaymau"
                                            onChange={value => setFieldValue("cot_ngaylaymau", value)}
                                            value={values.cot_ngaylaymau}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_ngaynhanmau}
                                            id="cot_ngaynhanmau"
                                            onChange={value => setFieldValue("cot_ngaynhanmau", value)}
                                            value={values.cot_ngaynhanmau}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_ngayphantich}
                                            id="cot_ngayphantich"
                                            onChange={value => setFieldValue("cot_ngayphantich", value)}
                                            value={values.cot_ngayphantich}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_luuluong}
                                            id="cot_luuluong"
                                            onChange={value => setFieldValue("cot_luuluong", value)}
                                            value={values.cot_luuluong}
                                            mandatory={false}
                                            width="50px"
                                        />
                                        <InputNumber min={0}
                                            label={typo.cscore_cot_nguonnuoc}
                                            id="cot_nguonnuoc"
                                            onChange={value => setFieldValue("cot_nguonnuoc", value)}
                                            value={values.cot_nguonnuoc}
                                            width="50px"
                                            mandatory={false}
                                        />
                                        <FastField name="kyhieuBoQua" render={({ field }) => (
                                            <InputCV label={typo.cscore_kyhieuBoQua} width="50px" mandatory={false} {...field} />)} />

                                        <FastField name="kyHieuNhoHon" render={({ field }) => (
                                            <InputCV label={typo.cscore_kyHieuNhoHon} width="50px" mandatory={false} {...field} />)} />

                                        <FastField name="kyhieuLonHon" render={({ field }) => (
                                            <InputCV label={typo.cscore_kyhieuLonHon} width="50px" mandatory={false} {...field} />)} />
                                    </ControllerInput>
                                </Col>
                            </Row>
                            <Row>
                                <Select
                                    modeSelect="multiple"
                                    placeholder={helper.genSelectPL(typo.cscore_drawer_qt_tt)}
                                    label="Danh sách thông số cần nhập số liệu"
                                    onChange={(value, name) => { setFieldValue("dsthongso", value); this.selectThongSo(value, name) }}
                                    dataSource={dataThongSo}
                                    width="100%"
                                    name="thongso"
                                    name_value="idThongSo"
                                    value={values.dsthongso}
                                    style={{ margin: "10px 0 20px 0" }}
                                />
                            </Row>
                            <Row>
                                <UpFile item={fileList} parentHandle={this.parentHandle} />
                            </Row>
                            <div className="mt-20" />
                            <Row type="flex" justify="end" align="middle">
                                <Button type="outline" onClick={() => { this.thietLapMau(values) }}><Icon type="download" />{typo.cscore_download_Excel}</Button>
                                <div className="ml-10" />
                                <Button type="submit" onClick={handleSubmit} disabled={!isEmpty(errors)}><Icon type="retweet" />{typo.cscore_convert_Excel}</Button>
                                <div className="ml-10" />
                                <Button type="cancel" onClick={() => handleCancel(fileList, user)}><Icon type="arrow-right" />{typo.cscore_exit}</Button>
                            </Row>
                            {/* <DisplayFormikState error={errors} value={values}/> */}
                        </form>
                    )} />
            </Modal>
        )
    };
}


ConvertExcel.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleAdd: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    doituongQT: PropTypes.string.isRequired
};

const mapStateToProps = (store) => ({
    user: store.oidc.user
});

export default connect(mapStateToProps)(ConvertExcel);

